import { Card, Icon } from "@/components/atoms";
import { BookingDetails } from "@/redux/slices/booking/types";
import { minutesToHoursToDaysExtended } from "@/utils";
import { DetailField } from "../../../../common/DetailField";

interface TransferTypeCardProps {
  booking: BookingDetails;
}

export const TransferTypeCard = ({ booking }: TransferTypeCardProps) => {
  const { transferType } = booking;

  const formatTransferType = () => {
    return ["hourly_rate", "daily_rate"].includes(transferType.type)
      ? `${transferType.name} (${minutesToHoursToDaysExtended(transferType.duration)})`
      : transferType.name;
  };

  return (
    <Card className="p-2.5">
      <DetailField
        leading={<Icon name="Car" size="lg" className="text-neutral-dark-gray" />}
        label="Transfer Type"
        value={formatTransferType()}
      />
    </Card>
  );
};
